import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { ProjetoDocumento } from '../../../models/projeto-documentos.model';
import { ProjetoDocumentoService } from '../../../services/projeto-documentos.service';

@Component({
  selector: 'app-projeto-documentos-edit',
  templateUrl: './projeto-documentos-edit.component.html',
  styleUrls: ['./projeto-documentos-edit.component.scss']
})
export class ProjetoDocumentosEditComponent extends BaseFormComponent<ProjetoDocumento> implements OnInit {

  idProjeto: number;
  actionLabel: string = 'Novo';
  selectedFile: File | null = null;
  list: any;
  type: boolean;

  constructor(
    private myService: ProjetoDocumentoService,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.list = this.activatedRoute.snapshot.data['list'];
    this.type = this.activatedRoute.snapshot.data['type'];
    if (!this.type) {
      this.list.typeList = this.list.typeList.filter(type => type.label != 'Cronograma');
    }
    this.initForm();
    this.loaded();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required]),
      type_id: new FormControl({ value: this.type ? this.list?.tpeIdCron : null, disabled: this.type }),
      file: new FormControl(null, [Validators.required]),
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
      this.form.get("file").clearValidators();
      this.form.get("file").updateValueAndValidity();
    } else {
      this.idProjeto = this.activatedRoute.snapshot.params['id'];
    }
  }

  voltar() {
    if (this.entity) {
      this.navigation.back(['/pre-projeto', 'projeto', this.entity?.pp_id, this.type ? 'cronograma' : 'documentos']);
    } else {
      this.navigation.back(['/pre-projeto', 'projeto', this.idProjeto, this.type ? 'cronograma' : 'documentos']);
    }
  }

  getDataCreate() {
    let data: ProjetoDocumento;
    data = Object.assign({}, data, this.form.value);

    if (!this.entity?.id) {
      data.pp_id = this.idProjeto;

      if (this.type) {
        data.type_id = this.list?.tpeIdCron;
      }
    }

    const formData: FormData = new FormData();
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        if (key == "file" && this.selectedFile) {
          formData.append('file', this.selectedFile, this.selectedFile?.name);
        }
        else {
          if (data[key]) {
            formData.append(key, data[key]);
          }
        }
      }
    }
    return formData;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      this.addSub(
        this.myService.createDocumento(this.getDataCreate()).subscribe({
          next: (res) => {
            this.confirmation('Documento criado com sucesso!').subscribe(() => {
              this.navigation.replace(['/pre-projeto', 'projeto', this.idProjeto, this.type ? 'cronograma' : 'documentos']);
            });
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    }
    else {
      this.markAsDirty();
    }
  }

  update(): void {
    if (this.form.valid && this.entity?.id) {
      this.loading();
      this.addSub(
        this.myService.updateDocumento(this.getDataCreate(), this.entity?.id).subscribe({
          next: (res) => {
            this.entity = res;
            this.msgSuccess('Documento alterado com sucesso!');
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    }
    else {
      this.markAsDirty();
    }
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.myService.delete(this.entity?.id).subscribe({
      next: (res) => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.voltar();
        });
      },
      error: (error) => {
        this.loaded();
      }
    });
  }

  onFileSelected(event: any): void {
    this.selectedFile = event?.target?.files[0];
  }

  download() {
    this.loading();
    this.addSub(
      this.myService.download(this.entity?.id).subscribe({
        next: (res) => {
          const contentDispositionHeader = res.headers.get('content-disposition');
          const fileName = contentDispositionHeader ? this.myService.extractFilename(contentDispositionHeader) : this.entity?.name;
          const blob = new Blob([res.body], { type: 'application/octet-stream' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(url);
          this.loaded();
        },
        error: (error) => {
          let msg;
          if (error?.status == 404) {
            msg = "Arquivo não encontrado.";
          }
          this.msgError(msg ? msg : error?.error?.message);
          this.loaded();
        },
      })
    );
  }
}